import { initMotionPreference } from './motionPreference.js';

initMotionPreference();
